<div class="mb-3">
  <h1 class="fs-5 fw-bold mb-0">Lead Log</h1>
</div>

<div class="card border-0 shadow mb-3 fade-in-zoom">
  <div class="card-header fw-bold bg-tertiary p-3 border-0">
    <h2 class="fs-6 fw-bold mb-0"><i class="bi bi-filter me-2 text-primary"></i>Filters</h2>
  </div>

  <div class="card-body">
    <app-log-filters [filters]="filters" (init)="fetchAll()"></app-log-filters>

    <div class="row g-3 align-items-end mb-4">
      <div class="col">
        <label for="cid" class="form-label">CID</label>
        <div class="input-group">
          <span class="input-group-text"><i class="bi bi-filter"></i></span>
          <input type="text" class="form-control" [(ngModel)]="filters['cid']" [ngModelOptions]="{standalone: true}">
        </div>
      </div>
      <div class="col">
        <label for="filterPartner" class="form-label">Typology</label>
        <div class="input-group">
          <span class="input-group-text"><i class="bi bi-bar-chart-steps"></i></span>
          <app-dropdown-select [multiple]="true" [(ngModel)]="filters['sourceTypology']"
            [ngModelOptions]="{standalone: true}">
            <app-dropdown-select-option value="p1">Registration (p1)</app-dropdown-select-option>
            <app-dropdown-select-option value="p2">COREG (p2)</app-dropdown-select-option>
            <app-dropdown-select-option value="xsell">CROSS SELL (xsell)</app-dropdown-select-option>
            <app-dropdown-select-option value="p0">Pre-registration (p0)</app-dropdown-select-option>
          </app-dropdown-select>
        </div>
      </div>
      <div class="col">
        <label for="status" class="form-label">Status</label>
        <div class="input-group">
          <span class="input-group-text"><i class="bi bi-check"></i></span>
          <select [(ngModel)]="filters['status']" [ngModelOptions]="{standalone: true}" class="form-control">
            <option [ngValue]="null">All</option>
            <option [ngValue]="'ok'">Succeeded ✅</option>
            <option [ngValue]="'ko'">Failed ⚠️</option>
            <option [ngValue]="'ar'">Already registered ❌️</option>
            <option [ngValue]="'reactivated'">Reactivated 🔁</option>
            <option [ngValue]="'p0'">Pre-registration 📝</option>
          </select>
        </div>
      </div>
      <div class="col">
        <label for="paid" class="form-label">Paid</label>
        <div class="input-group">
          <span class="input-group-text"><i class="bi bi-cash-coin"></i></span>
          <select [(ngModel)]="filters['paid']" [ngModelOptions]="{standalone: true}" class="form-control">
            <option [ngValue]="null">All</option>
            <option [ngValue]="true">Yes</option>
            <option [ngValue]="false">No</option>
          </select>
        </div>
      </div>
      <div class="col">
        <label for="fingerprint" class="form-label">Fingerprint</label>
        <div class="input-group">
          <span class="input-group-text"><i class="bi bi-fingerprint"></i></span>
          <select [(ngModel)]="filters['fingerprint']" [ngModelOptions]="{standalone: true}" class="form-control">
            <option [ngValue]="null">All</option>
            <option [ngValue]="true">With</option>
            <option [ngValue]="false">Without</option>
          </select>
        </div>
      </div>
      <div class="col" *isGranted="['ROLE_API_EMAIL_PLAINTEXT']">
        <label for="email" class="form-label">Email</label>
        <div class="input-group">
          <span class="input-group-text"><i class="bi bi-envelope"></i></span>
          <input type="text" class="form-control" [(ngModel)]="filters['email']" [ngModelOptions]="{standalone: true}">
        </div>
      </div>
    </div>

    <div class="row g-3 align-items-end mb-4">
      <div class="col-auto ms-auto">
        <button (click)="downloadCsv()" [disabled]="downloading" class="btn btn-secondary fw-bold me-2">
          @if (downloading) {
            <app-csv-export-progress [current]="exportProgress?.current ?? 0"
                                     [total]="exportProgress?.total ?? 0">
            </app-csv-export-progress>
          } @else {
            CSV
          }
        </button>
        <button type="submit" class="btn btn-primary fw-bold" (click)="applyFilters()">Apply Filters</button>
      </div>
    </div>

    <app-display-table-column [data]="displayedColumns"></app-display-table-column>

    <div class="table-responsive">
      <table class="table table-striped table-hover table-fixed-columns my-4" id="leads">
        <thead>
          <tr [tableSorter]="tableSorter" (tableSorterChange)="fetchAll()">
            <th tableSorterHeader="id">ID</th>
            <th tableSorterHeader="createdAt">Date</th>
            <th>Site</th>
            <th>Email</th>
            <th>Typology</th>
            <th>P2</th>
            <th>XSELL</th>
            @if (displayedColumns.cid) {
              <th>CID</th>
            }
            @if (displayedColumns.product) {
              <th>Brand</th>
            }
            @if (displayedColumns.offer) {
              <th>Offer</th>
            }
            @if (displayedColumns.landingPage) {
              <th>Promotion link</th>
            }
            @if (displayedColumns.partner) {
              <th>Partner</th>
            }
            @if (displayedColumns.subid) {
              <th>SubID</th>
            }
            @if (displayedColumns.tc1) {
              <th>Tracker 1</th>
            }
            @if (displayedColumns.tc2) {
              <th>Tracker 2</th>
            }
            @if (displayedColumns.tc3) {
              <th>Tracker 3</th>
            }
            @if (displayedColumns.tc4) {
              <th>Tracker 4</th>
            }
            @if (displayedColumns.clickid) {
              <th>Click ID</th>
            }
            @if (displayedColumns.ip) {
              <th>IP</th>
            }
            @if (displayedColumns.firstname) {
              <th>Firstname</th>
            }
            @if (displayedColumns.language) {
              <th>Language</th>
            }
            @if (displayedColumns.country) {
              <th>Country</th>
            }
            @if (displayedColumns.cost) {
              <th>Cost</th>
            }
            @if (displayedColumns.sourceType) {
              <th>Source type</th>
            }
            @if (displayedColumns.sourceDetails) {
              <th>Source details</th>
            }
            <th>Status</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          @for (lead of leads; track lead) {
            <tr>
              <td>{{ lead.id }}</td>
              <td>{{ lead.createdAt | parisDate }}</td>
              <td>{{ lead.site }}</td>
              <td>{{ lead.email }}</td>
              <td>{{ lead.sourceTypology }}</td>
              <td>{{ lead.coreg }}</td>
              <td>{{ lead.cross }}</td>
              @if (displayedColumns.cid) {
                <td><a href="javascript:void(0)"
                (click)="openClickDetail(lead)">{{ lead.cid }}</a></td>
              }
              @if (displayedColumns.product) {
                <td>{{ lead.product }}</td>
              }
              @if (displayedColumns.offer) {
                <td>{{ lead.offer }}</td>
              }
              @if (displayedColumns.landingPage) {
                <td>{{ lead.landingPage }}</td>
              }
              @if (displayedColumns.partner) {
                <td>{{ lead.partner }}</td>
              }
              @if (displayedColumns.subid) {
                <td>{{ lead.subid }}</td>
              }
              @if (displayedColumns.tc1) {
                <td>{{ lead.tc1 }}</td>
              }
              @if (displayedColumns.tc2) {
                <td>{{ lead.tc2 }}</td>
              }
              @if (displayedColumns.tc3) {
                <td>{{ lead.tc3 }}</td>
              }
              @if (displayedColumns.tc4) {
                <td>{{ lead.tc4 }}</td>
              }
              @if (displayedColumns.clickid) {
                <td>{{ lead.clickid }}</td>
              }
              @if (displayedColumns.ip) {
                <td>{{ lead.ip }}</td>
              }
              @if (displayedColumns.firstname) {
                <td>{{ lead.firstname }}</td>
              }
              @if (displayedColumns.language) {
                <td>{{ lead.language }}</td>
              }
              @if (displayedColumns.country) {
                <td class="text-nowrap">
                  @if (lead.country) {
                    <img [ngSrc]="countryService.getFlag(lead.country)" [alt]="lead.country"
                      [title]="lead.country" width="24" height="24" class="me-1">{{ lead.country }}
                  }
                </td>
              }
              @if (displayedColumns.cost) {
                <td>{{ lead.cost | money }}</td>
              }
              @if (displayedColumns.sourceType) {
                <td>{{ lead.sourceType }}</td>
              }
              @if (displayedColumns.sourceDetails) {
                <td>
                  @if (lead.sourceDetails) {
                    <code class="source-details small" [title]="lead.sourceDetails | json">{{ lead.sourceDetails | json }}</code>
                  }
                </td>
              }
              <td class="text-nowrap">
                <span [innerHTML]="leadService.getHtmlStatusIcon(lead)" [appTooltip]="leadService.getHtmlStatus(lead)"></span>
                @if (lead.fingerprintSent) {
                  <i class="bi bi-fingerprint text-primary ms-1" appTooltip="Fingerprint collected and sent to LeadUp"></i>
                }
              </td>
              <td>
                @if (lead.id) {
                  <button (click)="openDetail(lead)" class="btn btn-primary btn-sm">
                    <i class="bi bi-eye-fill"></i>
                  </button>
                }
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>

    <app-paginator (pageChange)="fetchAll()" [paginator]="paginator"></app-paginator>
  </div>
</div>
